import React, {useState} from 'react';

import {getConfig} from '../config';

const UserContext = React.createContext();

const UserContextProvider = ({children}) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem(getConfig("userLocalStorage"))));

  return (
    <UserContext.Provider value={{user, setUser}}>
      {children}
    </UserContext.Provider>
  )
}

export {UserContextProvider, UserContext}
